<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        {{ $t('ITEM.CREATE') }} {{ $t('EREPORTER.INVOICES.LINE') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <component :is="componentName" v-model="localLine"></component>
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="update">
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import invoiceLine from './mixins/invoiceLine';

export default {
  name: 'CreateInvoiceLine',

  mixins: [invoiceLine],

  methods: {
    update() {
      this.$emit('create', { ...this.localLine });
    }
  }
};
</script>
